import * as React from 'react';
import {IconButton} from '@wix/wix-ui-tpa/cssVars';
import {ChevronRight} from '../../../../../icons/dist';
import s from './Arrow.scss';
import {classes as arrowStylable} from './Arrow.st.css';
import classNames from 'classnames';
import {withGlobals} from '../../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../../gallery/galleryGlobalStrategy';

export enum ArrowDirection {
  RIGHT = 'right',
  LEFT = 'left',
}

export interface ArrowProps extends IGalleryGlobalProps {
  onClick(): void;
  onKeyPress(): void;
  direction: ArrowDirection;
  ariaLabel: string;
  className?: string;
  dataHook: string;
}

const ArrowWithoutGlobals: React.FC<ArrowProps> = ({
  onClick,
  onKeyPress,
  direction,
  ariaLabel,
  className,
  dataHook,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onClick();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onKeyPress();
  };

  return (
    <div className={classNames(s.arrowContainer, s[direction], className)}>
      <IconButton
        type="button"
        onClickCapture={handleClick}
        onKeyPressCapture={handleKeyPress}
        data-hook={dataHook}
        aria-label={ariaLabel}
        className={classNames(s.arrow, s[direction], arrowStylable.arrowButton)}
        icon={<ChevronRight className={s.chevron} />}
      />
    </div>
  );
};

export const Arrow = withGlobals(ArrowWithoutGlobals);
